"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TYPE = void 0;
/** Supported types */
var TYPE;
(function (TYPE) {
    TYPE["PLAIN_TEXT"] = "plain-text";
})(TYPE || (exports.TYPE = TYPE = {}));
//# sourceMappingURL=plain-types.js.map